import React from 'react';
import {InputGenerator} from '../types';
import {FormControl} from 'react-reactive-form';
import {InputType, MultiSelectInputAttributes} from '../../InputDefinition/types';
import {selectInputPrimitiveControlBuilder, SelectItemPrimitive} from '../primitives/SelectItemPrimitive';
import InputHeader from './InputHeader';
import StaticInputSelectPrimitive from '../primitives/StaticInputSelectPrimitive';

type SingleSelectInputProps = {
  control: FormControl;
  definition: MultiSelectInputAttributes;
  disabled?: boolean;
};

export const MultiSelectInput: React.FC<SingleSelectInputProps> = ({control, definition, disabled}) => {
  return (
    <>
      <InputHeader definition={definition} />
      <SelectItemPrimitive control={control} definition={definition} disabled={disabled} />
    </>
  );
};

export const multiSelectInputGenerator: InputGenerator<InputType.MULTI_SELECT> = {
  type: InputType.MULTI_SELECT,
  buildControl: (definition, initialValues) => {
    return selectInputPrimitiveControlBuilder(definition, initialValues);
  },
  render: React.memo(MultiSelectInput),
  renderStatic: React.memo(StaticInputSelectPrimitive),
};
